import { TOrganizationLead } from '@/types/OrganizationLeads.types';
import { usePagination } from '../usePagination';
import queryKeys from '@/constants/queryKeys';
import { TSortingParams } from '@/types';
import { getAllOrganizationLeads } from '@/services/api/requests/organizationLeads';

export const useOrganizationLeads = ({ sortingColumn, sortingDirection }: TSortingParams) => {
  return usePagination<TOrganizationLead[], { searchText: string }>({
    query: getAllOrganizationLeads,
    queryKey: queryKeys.organizationLeads.allLeads,
    sortingColumn,
    sortingDirection,
  });
};
